import React, { Component } from 'react';

import { EnumPaymentMethod } from '../../../../../constants/enum';
import { trans } from '../../../../../localization';

import CreditIcon from '../../../../../assets/common/static/icons/credit-card.png'

class CustomerPaymentBy extends Component {
  render() {
    const { customerPay } = this.props;
    const { type: paymentType } = customerPay;
    return (
      <React.Fragment>
        {paymentType === EnumPaymentMethod.COD.id ? (
          <i
            className="icon icon-money"
            title={trans('mod_order_detail_payment_via_cod')}
          />
        ) : (
          <span title={trans('mod_order_detail_payment_via_online')}>
            <img src={CreditIcon} alt={trans('mod_order_detail_payment_via_online')} className="credit-icon" />
            {/* <i
              className="far fa-credit-card font15 text-green"
              title={trans('mod_order_detail_payment_via_online')}
            /> */}
          </span>
        )}
      </React.Fragment>
    );
  }
}
export default CustomerPaymentBy;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/CustomerPaymentBy.jsx